var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AbfragerMemorizePointsWordTask_1;
import React from 'react';
import { observer } from 'mobx-react';
import { Actor_ } from '../../../../components/actor/Actor_';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
let AbfragerMemorizePointsWordTask = AbfragerMemorizePointsWordTask_1 = class AbfragerMemorizePointsWordTask extends React.PureComponent {
    static get structureTemplate() {
        return (React.createElement("div", { "data-aspect": "inner", style: {
                flex: '0 0 90px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                paddingTop: 20,
            } },
            React.createElement("div", { "data-aspect": "prefix", className: "abfrager_MemorizePoints_prepost", style: { marginRight: 12 } }),
            React.createElement("div", { "data-aspect": "main", style: { flex: '0 0 auto' } },
                React.createElement("input", { type: "text", "data-aspect": "input", className: "knowaword_input" })),
            React.createElement("div", { "data-aspect": "postfix", className: "abfrager_MemorizePoints_prepost", style: { marginLeft: 12 } })));
    }
    render() {
        const { task } = this.props;
        return React.createElement(Actor_, { actor: task, structureTemplate: AbfragerMemorizePointsWordTask_1.structureTemplate });
    }
};
__decorate([
    memoize
], AbfragerMemorizePointsWordTask, "structureTemplate", null);
AbfragerMemorizePointsWordTask = AbfragerMemorizePointsWordTask_1 = __decorate([
    observer
], AbfragerMemorizePointsWordTask);
export { AbfragerMemorizePointsWordTask };
